import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MainNavigator } from '@/app/navigation/MainNavigator';

export default function App() {
  return (
    <BrowserRouter>
      <MainNavigator />
    </BrowserRouter>
  );
}

